var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewoffDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.994,
    height: 14.604,
    viewBox: "0 0 21.994 14.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_Icon",
    "data-name": "View Icon",
    transform: "translate(-1220 -1991.183)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_427",
    "data-name": "Union 427",
    d: "M9280.134,19805.3a.821.821,0,0,1,0-.91c.184-.273,4.013-6.848,10.859-6.848s10.68,6.574,10.859,6.848a.821.821,0,0,1,0,.91c-.18.273-4.013,6.846-10.859,6.846S9280.317,19805.574,9280.134,19805.3Zm1.914-.459c.915,1.373,4.107,5.48,8.945,5.48s8.03-4.107,8.944-5.48c-.914-1.367-4.106-5.475-8.944-5.475S9282.963,19803.475,9282.048,19804.842Zm5.221.006a3.724,3.724,0,1,1,3.725,3.689A3.72,3.72,0,0,1,9287.269,19804.848Zm1.859,0a1.862,1.862,0,1,0,1.865-1.85A1.861,1.861,0,0,0,9289.128,19804.848Z",
    transform: "translate(-8059.995 -17806.359)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewoffDark);
export default __webpack_public_path__ + "static/media/icon_viewoff_dark.59c111a4a76ea020cbeb7a099ddb3134.svg";
export { ForwardRef as ReactComponent };